function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.4;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{opacity:0.21;mix-blend-mode:multiply;fill:url(#Degradado_sin_nombre_94);}.cls-16{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 114.9,
  y1: 91.5,
  x2: 94.65,
  y2: 169.82,
  gradientTransform: "matrix(0.99, -0.1, 0.1, 0.99, -4.33, 11.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00d9ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005eef"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 25.39,
  y1: 70.27,
  x2: 1.47,
  y2: 162.82,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 131.01,
  y1: 89.75,
  x2: 108.08,
  y2: 178.43,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 97.31,
  y1: 85.02,
  x2: 71.48,
  y2: 184.93,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 58.43,
  y1: 78.06,
  x2: 33.38,
  y2: 174.96,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 83.5,
  y1: 83.99,
  x2: 61.34,
  y2: 169.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 143.28,
  y1: 96.16,
  x2: 123.97,
  y2: 170.85,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 43.5,
  y1: 75.88,
  x2: 22.52,
  y2: 157.04,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 79.81,
  y1: 81.81,
  x2: 65.42,
  y2: 137.48,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 113.43,
  y1: 88.67,
  x2: 99.5,
  y2: 142.53,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 34.93,
  y1: 75.14,
  x2: 18.87,
  y2: 137.28,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 103.92,
  y1: 1.6,
  x2: 84.21,
  y2: 110.51,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_94",
  x1: 54.26,
  y1: 87.13,
  x2: 86.74,
  y2: -34.93,
  gradientTransform: "matrix(0.99, -0.1, 0.1, 0.99, -4.33, 11.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f4a4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#b78aed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#855fed"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 133.27,
  y1: 7.11,
  x2: 133.27,
  y2: 140.83,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M109.27,90.79c5.17,7.12,10.36,15.62,8.81,24.82-1.12,6.66-5,12.52-6.82,19-3.61,12.64-.35,26.37,3.72,38.51.38,1.15,2.38.71,2.12-.51-1.69-7.9-3.9-15.65-4.2-23.77-.33-9.22,2.68-16.46,5.95-24.82,5.17-13.24.71-23.89-7.85-34.46-.86-1-2.54.14-1.73,1.26Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M41,79.85c-21.74,2.84-12.61,34.84-15.5,49-2.18,10.67-14.77,13-20.54,21.34a26.55,26.55,0,0,0-4,22.58c.6,2,3.68,1.14,3.54-.85-.63-9,1.63-18,9.13-23.76C19.24,143.9,26,141.77,29.18,135c2.82-6,2.24-12.72,2-19.1-.38-8.84-1.5-30,10.21-32.72,2-.48,1.88-3.65-.34-3.36Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M121.06,87.34c5.19,8,11.21,16.84,12.18,26.61.9,9-4.11,17-6.65,25.31-4.06,13.32-2.66,30.9,6.41,42a1.42,1.42,0,0,0,2.46-1.34c-3.4-9.35-6.43-17.81-5.57-28,.77-9.21,4.83-17.08,7.42-25.78,4.73-15.9-3.51-29.09-13.29-41a1.83,1.83,0,0,0-3,2.16Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M98.76,85.57c-14.45,14-4.71,35.28-3.88,52.2.54,10.92-4.11,19.85-8.21,29.62-2.88,6.87-5.63,14.48-3.57,21.93.5,1.81,3.52,1.47,3.68-.37a71.19,71.19,0,0,1,6.58-24.15c3.14-7,6.16-14,6.6-21.77,1.05-18.39-10.66-38.45,1.6-55.18a1.81,1.81,0,0,0-2.8-2.28Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M76.12,84.72c-7.4-2.89-15.09.86-19.06,7.55-5.73,9.66-2.56,22.59-1.33,33,1.56,13.18,5.36,30.72-7.1,40-6.48,4.81-15.69,6.07-17.56,15a1.47,1.47,0,0,0,2.57,1.17c4.83-6.8,13.08-8.27,19.26-13.31s8.9-12.7,9.48-20.34C63.31,135.6,49.11,82,75.1,88.05c1.93.45,2.87-2.6,1-3.33Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M86,86.29c-13.85,9.38-5.88,27.07-4.32,40.13,1.33,11-3.86,19.78-6,30.15-1.44,6.84-1.17,14,3.78,19.37a.81.81,0,0,0,1.3-.95c-8.61-14.86,3.87-28.77,3.74-44-.12-14-9.8-31.56,2.81-43A1.08,1.08,0,0,0,86,86.29Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M143.73,92.11c-11.13,12.94,6,28.2,1.58,42.2C141.66,145.88,127,157,135.24,170c.73,1.14,2.74.08,2.12-1.16-6.86-13.61,8.73-23.49,11.28-35.9,2.75-13.34-12.12-27.13-3.29-39.54a1,1,0,0,0-1.62-1.33Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M46.64,84.08c11,16.3-12.28,21.43-13.31,35.57-.52,7.21,4.05,13.58,5,20.55C39.69,149.59,35.1,158,28.19,164a1.33,1.33,0,0,0,1.57,2.15,27.6,27.6,0,0,0,11.31-17c1.94-8.77-1.67-15.37-3.73-23.66-3.14-12.62,8.78-15.62,13.51-24.93,3.06-6,1.84-12.73-2.3-17.86a1.18,1.18,0,0,0-1.91,1.4Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M89.42,87.16c1.17,1.36,0,5.49-.59,7.06a20.18,20.18,0,0,1-3.73,5.42,48.46,48.46,0,0,1-8.24,6.88c-3.75,2.68-6.9,5.43-8.38,9.94-3.24,9.87,2.48,20.65,9.69,27.19,1.08,1,2.54-.56,1.79-1.7-4-6.13-8.87-11.78-8.86-19.5,0-9.34,7.24-12.31,13.18-17.85,4.08-3.81,12.24-13.47,6.63-18.85-.84-.8-2.25.52-1.49,1.41Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M113,87.44a22.85,22.85,0,0,0-7.42,22.36c1,4.6,3.39,7.92,6.42,11.42,6.11,7.05,6,14.89,4.73,23.66a1.05,1.05,0,0,0,2.07.35c2.8-9.38,1.94-18.21-4.5-25.68-8-9.25-9-21.41.08-30.64.81-.82-.51-2.22-1.38-1.47Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M52.16,85.75C53.57,95,44.31,99.2,37.63,102.93c-5.65,3.15-11.36,6.64-16.13,11-9.16,8.47-9.74,19.1-7.26,30.75.27,1.27,2.19,1.15,2.06-.21-.78-8.28-2.08-16.72,2.88-24,4.42-6.5,12-11.17,18.71-15,7.89-4.47,18.75-9,16.56-20-.29-1.42-2.51-1.25-2.29.23Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M155.5,84.36a13.16,13.16,0,0,1-13.73,8.81L82.34,87.44,41.55,83.51a13.07,13.07,0,0,1-11.8-11.3c-4.39-37,32.79-81,77.49-70.7a68.71,68.71,0,0,1,18,7.05C167.05,31.82,161.36,67.35,155.5,84.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M66.16,56.85c2.29,9.65,7.48,18.54,13.35,26.45.51.68,1.56,2.33,2.83,4.14L41.55,83.51a13.07,13.07,0,0,1-11.8-11.3c-4.39-37,32.79-81,77.49-70.7-3.57,1.48-6.87,3.18-8.68,4.06C79,15.27,60.6,33.37,66.16,56.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M118.08,12c19.42,1.16,37.14,27.54,36.81,45.71-.54,29.27-22.33,39.08-28.61,11.67s-2.47-24.29-13.43-40.13c-3.91-5.65-6-16.61,4-17.25C117.25,12,117.66,12,118.08,12Z"
}))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159.56 190.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.cfe84ef6.svg";
export { ForwardRef as ReactComponent };